import React from 'react'

import { Portlet } from '_zari/core'

import MainForm from './mainForm'

const NuevoPage = () => {
  return (
    <Portlet>
      <Portlet.Header title='NUEVA COMPAÑIA' />
      <Portlet.Body>
        <MainForm />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoPage)
